import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectSeries } from "~components/SelectSeries/SelectSeries";
import type { FixtureTransformed } from "~pages/Fixtures/types";
import type { ColumnComponentProperties } from "../../types";

interface ISeriesColumnProperties extends ColumnComponentProperties {
  fixture: FixtureTransformed;
}

export const SeriesColumn = (properties: ISeriesColumnProperties) => {
  const { formatMessage } = useIntl();

  if (properties.editMode) {
    const value = isEmpty(properties.fixture.series)
      ? null
      : {
          label: properties.fixture.series.nameLocal,
          value: properties.fixture.series.seriesCode,
        };

    const onChangeHandler = (seriesOption: InfinitySelectOption | null) =>
      properties.updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          seriesCode: seriesOption?.value ? seriesOption?.value : null,
        },
        oldSeriesCode: properties.fixture?.series?.seriesCode ?? null,
      });

    return (
      <SelectSeries
        disabled={properties.isUpdatePending}
        placeholder={formatMessage({
          id: "fixtureListPage.table.column.editMode.series.placeholder",
        })}
        value={value}
        onChange={onChangeHandler}
        stageCode={properties.fixture?.stage?.stageCode}
      />
    );
  }

  return properties.fixture.series?.nameLocal;
};
